import React from 'react';
import { Check, Shield, Zap, Settings, Star, TrendingUp, CreditCard, Send, Lock, Store, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Shield,
  title: 'Diseño Premium',
  desc: 'Mobile-first y optimizado'
}, {
  icon: Star,
  title: 'Credibilidad',
  desc: 'Reseñas y galería de proyectos'
}, {
  icon: TrendingUp,
  title: 'Crecimiento',
  desc: 'SEO Local y Google Business'
}];
export function PricingSection() {
  return <section id="servicios" className="py-24 bg-dark relative" data-id="element-275">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-276"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-278">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-279">
            Todo Lo Que Necesitas. <br className="hidden md:block" data-id="element-280" />
            <span className="text-gold" data-id="element-281">Un Solo Pago.</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-282">
          {/* Main Pricing Card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-gradient-to-br from-dark-100 to-dark-200 rounded-3xl border-2 border-gold p-8 md:p-10 shadow-[0_0_40px_rgba(212,175,55,0.15)] relative overflow-hidden" data-id="element-283">
            <div className="absolute top-0 right-0 bg-gold text-dark font-bold px-6 py-2 rounded-bl-2xl text-sm uppercase tracking-wider z-10" data-id="element-284">
              Oferta Principal
            </div>

            <div className="relative -mx-8 md:-mx-10 -mt-8 md:-mt-10 mb-8 rounded-t-3xl overflow-hidden" data-id="element-285">
              <img src="https://cdn.magicpatterns.com/uploads/joXRLUuV19avwWiRtVmmjh/heylloyd-image-1782678468852.png" alt="Ejemplo de website profesional para contratistas mostrado en una laptop" className="w-full h-64 md:h-72 object-cover object-[center_38%]" data-id="element-286" />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-100 via-dark-100/20 to-transparent" data-id="element-287"></div>
            </div>

            <div className="mb-8" data-id="element-288">
              <h3 className="flex items-center gap-2 text-xl font-bold text-white mb-4" data-id="element-289">
                <Zap className="w-5 h-5 text-gold" data-id="element-290" />
                WEBSITE COMPLETO
              </h3>
              <div className="flex items-baseline mb-2" data-id="element-291">
                <span className="text-6xl font-extrabold text-gold" data-id="element-292">$250</span>
                <span className="text-gray-400 ml-2 font-medium" data-id="element-293">
                  pago único
                </span>
              </div>
            </div>

            <div className="space-y-4 mb-8" data-id="element-294">
              {['Solo $125 para empezar (50%)', 'Resto al entregar tu website', 'Sin contratos ni mensualidades', 'Listo en menos de 72 horas'].map((text, i) => <div key={i} className="flex items-center gap-3" data-id="element-295">
                  <div className="bg-gold/20 p-1 rounded-full shrink-0" data-id="element-296">
                    <Check className="w-4 h-4 text-gold" data-id="element-297" />
                  </div>
                  <span className="text-white font-medium" data-id="element-298">{text}</span>
                </div>)}
            </div>

            <a href="https://wa.me/447311754270?text=WEBSITE" target="_blank" rel="noopener noreferrer" className="block w-full py-4 text-center bg-gold hover:bg-gold-400 text-dark font-bold rounded-xl transition-colors" data-id="element-299">
              EMPEZAR AHORA
            </a>

            {/* Payment methods */}
            <div className="mt-6 pt-6 border-t border-white/10" data-id="element-300">
              <div className="flex items-center justify-center gap-2 text-gray-400 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-301">
                <Lock className="w-3.5 h-3.5 text-gold" data-id="element-302" />
                Métodos de pago seguros
              </div>
              <div className="flex flex-wrap items-center justify-center gap-3" data-id="element-303">
                <div className="flex items-center gap-2 bg-dark-300/60 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-304">
                  <Send className="w-4 h-4 text-gold" data-id="element-305" />
                  <span className="text-white font-semibold text-sm" data-id="element-306">
                    Zelle
                  </span>
                </div>
                <div className="flex items-center gap-2 bg-dark-300/60 border border-white/10 rounded-xl px-4 py-2.5" data-id="element-307">
                  <CreditCard className="w-4 h-4 text-gold" data-id="element-308" />
                  <span className="text-white font-semibold text-sm" data-id="element-309">
                    Tarjeta
                  </span>
                  <span className="text-gray-500 text-xs" data-id="element-310">vía Stripe</span>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Features & Maintenance */}
          <div className="space-y-6" data-id="element-311">
            <div className="grid gap-4" data-id="element-312">
              {features.map((feat, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} className="bg-dark-100 p-5 rounded-2xl border border-white/5 flex items-center gap-4" data-id="element-313">
                  <feat.icon className="w-8 h-8 text-gold shrink-0" data-id="element-314" />
                  <div data-id="element-315">
                    <h4 className="text-white font-bold" data-id="element-316">{feat.title}</h4>
                    <p className="text-gray-400 text-sm" data-id="element-317">{feat.desc}</p>
                  </div>
                </motion.div>)}
            </div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} className="bg-dark-200 rounded-2xl border border-white/10 p-6 flex items-center justify-between" data-id="element-318">
              <div data-id="element-319">
                <div className="inline-flex items-center gap-2 text-gray-400 font-bold uppercase text-xs mb-1" data-id="element-320">
                  <Settings className="w-4 h-4" data-id="element-321" /> Opcional
                </div>
                <h4 className="text-white font-bold" data-id="element-322">Mantenimiento</h4>
                <p className="text-gray-400 text-sm" data-id="element-323">
                  Actualizaciones y soporte
                </p>
              </div>
              <div className="text-right" data-id="element-324">
                <div className="text-2xl font-bold text-white" data-id="element-325">$30</div>
                <div className="text-xs text-gray-500" data-id="element-326">/ mes</div>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Other businesses note */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="mt-10 bg-dark-100 border border-gold/20 rounded-2xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left" data-id="element-327">
          <div className="flex items-center gap-4" data-id="element-328">
            <div className="shrink-0 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gold/15 text-gold" data-id="element-329">
              <Store className="w-6 h-6" data-id="element-330" />
            </div>
            <div data-id="element-331">
              <h4 className="text-white font-bold" data-id="element-332">
                ¿Tienes otro tipo de negocio?
              </h4>
              <p className="text-gray-400 text-sm" data-id="element-333">
                También creamos websites para cualquier negocio. Pregúntanos sin
                compromiso.
              </p>
            </div>
          </div>
          <a href="https://wa.me/447311754270?text=Hola,%20me%20interesa%20un%20website%20para%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="shrink-0 inline-flex items-center gap-2 py-3 px-6 bg-gold/10 hover:bg-gold hover:text-dark text-gold font-bold rounded-xl border border-gold/30 transition-colors" data-id="element-334">
            Pregúntanos
            <ArrowRight className="w-4 h-4" data-id="element-335" />
          </a>
        </motion.div>
      </div>
    </section>;
}